import moment from 'moment'
import { hexToRgb } from '../../../common/helper'
import { headColor } from '../../dashBoard/businessAnalysis'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import { withPxWidths } from '../../../common/mathHelper'
import autoTable from 'jspdf-autotable'
import { xlCol } from '../../../common/constants'
import { lrDetailPdfFooter } from '../../AcountingReport/common/AcountingConstants'

export const makeTable = (doc, autoTable, header, body, pdfFontSize, reportname, loginData, showHead = "everyPage", customFunction = false, topMargin = 120, lastColor = true) => {
  const columnStyles = {}
  header.forEach((col, index) => {
    if (col.width) {
      columnStyles[index] = {
        cellWidth: parseInt(col.width),  
        overflow: parseInt(col.width)?'linebreak':'auto', 
      }
    }
  })
  return autoTable(doc, {
    startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 40 : topMargin,
    margin: { top: 120, left: 30, right: 30, bottom: 30 },
    alternateRowStyles: { fillColor: [255, 255, 255] },
    columns: header,
    theme: 'grid',
    showHead: showHead,
    body: body,
    headStyles: {
      minCellHeight: 36,
      valign: 'middle',
      lineWidth: { top: 0.5, bottom: 0.5, left: 0, right: 0 },
    },
    bodyStyles: {
      minCellHeight: 26,
      valign: 'middle',
      lineWidth: { top: 0.3, bottom: 0.3, left: 0, right: 0 },
    },
    styles: {
      fontSize: pdfFontSize * 14,
      cellWidth: 'wrap',         
      overflow: 'linebreak',     
      whiteSpace: 'normal',      
      wordBreak: 'break-word',   
      valign: 'top',             
      minCellHeight: 26,
    },
    columnStyles,
    willDrawCell: (data) => {
      const isLastColumn = data.column.index === data.table.columns.length - 1
      data.cell.styles.valign = 'middle'
      doc.setFontSize(pdfFontSize * 14).setFont('Roboto', 'normal')
      const rowType = data.row.raw.dataType
      const hexColor = headColor[rowType] || headColor.header
      const rgb = hexToRgb(hexColor)
      doc.setFillColor(...rgb)
      if (isLastColumn && lastColor && rowType === 'entry') {
        doc.setTextColor(0, 134, 255)
      } else {
        doc.setTextColor(0, 0, 0)
      }
    },
    didParseCell: (data) => {

      const colDef = data.column.raw
      const colSpanMap = data?.row?.raw?.colSpan || {}
      const columnKey = data.column.dataKey
      const alignMap = data?.row?.raw?.align || {};
      if (['string'].includes(colDef.xlCol.dataType)) {
        data.cell.styles.halign = 'left'
      } else if (['quantity', 'number'].includes(colDef.xlCol.dataType) && data.row.raw.dataType !== 'subHeader') {
        data.cell.styles.halign = 'right'
      }
      if (alignMap.hasOwnProperty(columnKey)) {
        data.cell.styles.halign = alignMap[columnKey];
      }
      if (colSpanMap.hasOwnProperty(columnKey)) {
        data.cell.colSpan = colSpanMap[columnKey]
      }
    },
    didDrawPage: (data) => {
      if (!customFunction) {
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(pdfFontSize * 20).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System | ${reportname}`, 90, 80)

        doc.setTextColor(0, 0, 0)
        doc.text(`Company Name : ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        doc.setFontSize(16)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
        doc.text(
          `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
          doc.internal.pageSize.width / 2 -
          (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
          2 +
          90,
          pageHeight - 5
        )
      } else {
        customFunction(data,doc)
      }
    }
  })
}
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
export const downloadPDF = (payload) => {
  const {
    reportName,
    criteriaHeaders,
    criteriaData,
    tableData,
    visibleColumns,
    loginData,
    hideHeader
  } = payload
  jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
  jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
  const HeaderColumns = criteriaHeaders.map((col) => {
    return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
  })
  const pdfFontSize = 1
  const orientation = visibleColumns.length > 14 ? 'l' : 'p'
  const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
  const pdfColumns = withPxWidths(visibleColumns, format[0] - 60).map((col) => {
    return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
  })
  const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
  var totalPagesExp = '{total_pages_count_string}'
  doc.setProperties({
    title: `${reportName}.pdf`,
    subject: `${reportName}`,
    author: 'Maven Tech Labs Pvt. Ltd.',
    keywords: 'maven tech, Cargo system, Receive',
    creator: 'MTLPL',
  })
  const customFunction = (data, doc) => {
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
  }
  const customFunction2 = (data, doc) => {
    lrDetailPdfFooter(data, loginData, totalPagesExp)
  }
  makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
  makeTable(doc, autoTable, pdfColumns, tableData, pdfFontSize, reportName, loginData, hideHeader ? 'never' : 'everyPage', customFunction2)

  doc.setFont('Roboto')
  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp)
  }
  doc.save(`${reportName} ${currentDateTime}.pdf`)
}



